/**
 * archive recipe js
 * js functions for the recipe finder and results page
 *
 */
(function ($) {
    SoyVay.archiveRecipes = (function () {
        function privateInit() {
            const $filters = $('.js-recipe-filters');
            const $results = $('.js-recipe-results');
            const $toggles = $('.js-recipe-toggles').find('[data-toggle]');
            const favoritesCookie = SoyVay.readCookie('favoriteRecipes');
            const favoritesArray = favoritesCookie ? JSON.parse(favoritesCookie) : [];

            if (favoritesArray.length > 0) {
                $('#my-favorites-filter').show();
            }

            const updateResults = function () {
                const uriRequest = window.location.href;
                // if js-load is not a param, add it to avoid page caching issues
                const jsRequest = uriRequest.indexOf('&js-load=1') > -1 ? uriRequest : `${uriRequest}&js-load=1`;
                $.get(jsRequest, (results) => {
                    $results.html(results);
                    updateFilters();
                    // $('.js-count').text(SoyVay.resultsCount);
                    SoyVay.handleFavorite.init();
                }).fail(() => {
                    console.log('could not get data');
                });
            };

            const updateLabels = function () {
                $filters.find('input[type=radio]').each(function (i) {
                    $(this).parent().removeClass('checked');
                    if ($(this).prop('checked')) {
                        $(this).parent().addClass('checked');
                    }
                });
            };

            // reset state of visible filter groups
            const hideFilters = function () {
                $filters.find('.recipe-filters__fieldset').removeClass('visible');
            };

            const updateToggles = function () {
                $toggles.removeClass('checked');
                const checkedFilters = $filters.find('.checked');
                checkedFilters.each(function (i) {
                    const winner = $(this).parents('.recipe-filters__fieldset').attr('id');
                    $(`[data-toggle=${winner}]`).addClass('checked');
                });
            };

            const clearFilters = function () {
                $filters.find('input[type=radio]').each(function (i) {
                    $(this).removeAttr('checked');
                });

                $filters.find('label').each(function (i) {
                    $(this).removeClass('selected');
                });

                if (typeof window.history.replaceState !== 'undefined') {
                    window.history.replaceState(null, 'Updated filters', '?');
                }

                updateLabels();
                updateToggles();
                hideFilters();
                updateResults();
            };

            const clearToggleSelection = function () {
                $toggles.each(function (i) {
                    $(this).removeClass('selected');
                    $(this).removeClass('checked');
                });
            };

            const updateFilters = function () {
                $('.js-recipe-filters').on('change', () => {
                    if (typeof window.history.replaceState !== 'undefined') {
                        let serialize = $('.js-recipe-filters').serialize();
                        // if request includes My Favorites include the cookie value to bypass caching
                        if (favoritesArray.length > 0 && serialize.indexOf('category=my-favorites') > -1) {
                            serialize += serialize.indexOf('&favorite=') > -1 ? '' : `&favorite=${favoritesCookie}`;
                        }
                        window.history.replaceState(null, 'Updated filters', `?${serialize}`);
                    }
                    updateLabels();
                    updateToggles();
                    updateResults();
                });
            };

            $toggles.on('click', function () {
                clearToggleSelection();
                hideFilters();
                $(this).addClass('selected');

                if ($(this).not('checked')) {
                    const winner = $(this).data('toggle');
                    $(`#${winner}`).addClass('visible');
                    $(`#${winner}`).find('.recipe-filters__filter').first().focus();
                }
            });

            $filters.find('.recipe-filters__filter').on('keydown', function (event) {
                if (event.which === 13) {
                    // enter
                    // simulate click to employ the filter
                    $(this).click();
                } else if (event.which === 27) {
                    // escape
                    // refocus to the toggle button that controls this set
                    const control = $(this).parents('.recipe-filters__fieldset').attr('id');
                    $(`[data-toggle=${control}]`).focus();
                }
            });

            $($toggles, $filters).on('keydown', (event) => {
                if (event.which === 8) {
                    // backspace
                    // clear all filters
                    clearFilters();
                    clearToggleSelection();
                }
            });

            $('[data-clear]').on('click', () => {
                clearFilters();
                clearToggleSelection();
            });

            updateLabels();
            updateToggles();
            updateFilters();
        }
        return {
            init() {
                privateInit();
            },
        };
    })();

    // document ready
    $(document).ready(() => {
        SoyVay.archiveRecipes.init();
    });
})(jQuery);
